export const INITIAL_IMG_SIZE = {
    width: 1920, 
    height: 1080
};

export enum SpecialRoutes {
    KSB_CENTER = 'ksb-center',
    KSB_TEAM = 'ksb-team'
}